import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {raise} from '@utilities/helpers.ts'
import {httpGetDisease} from './treatment-requests.http'
import {DiseaseExtended} from '@/features/treatment-requests/types'

export const useDisease = (
    diseaseId?: string,
    options?: Omit<UseQueryOptions<DiseaseExtended>, 'queryKey' | 'queryFn'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.PATIENTS, diseaseId],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetDisease({
                    urlParams: {diseaseId: diseaseId ?? raise('diseaseId is nullish')},
                    params: {responseType: 'extended'}
                }),
                onZodError: captureException,
                responseShape: DiseaseExtended
            }),
        ...options
    })
